<template>
  <AppTabRoute :tabs="tabs"></AppTabRoute>
</template>

<script>
export default {
  name: 'CashFlowTabs',
  computed: {
    tabs() {
      if ((this.$route.name || '').includes('customer')) {
        return [
          { name: 'Listagem', route: 'customer-service.list' },
          { name: 'Tipos', route: 'customer-service-type.list' },
        ];
      }
      return [
        { name: 'Listagem', route: 'service.list' },
        { name: 'Tipos', route: 'service-type.list' },
      ];
    },
  },
};
</script>

<style>
</style>